import React from 'react';

import {
  Button,
  Col,
  FormattedTextField,
  MortgageHeader,
  Row,
} from '@elevationscu/ui-component-lib';

import { getPMICalculation } from '@elevationscu/common-mortgage-calculator';
import '../styles/common.scss';
import './New.scss';

function TestPmiCalculator() {
  const applyLink = 'https://applymortgage.elevationscu.com/#/milestones';
  const isMobile = false;

  const [originalBalance, setOriginalBalance] = React.useState();
  const [saleAmount, setSaleAmount] = React.useState();
  const [fico, setFico] = React.useState();
  const [pmi, setPmi] = React.useState(null);

  const handleCalculate = () => {
    const ficoInfo = {
      originalBalance,
      saleAmount,
      fico,
    };
    const tempPmi = getPMICalculation(ficoInfo);
    setPmi(tempPmi);
  };

  const handleOriginalBalanceChange = (event) => {
    setOriginalBalance(event.target.value);
  };

  const handleSaleAmountChange = (event) => {
    setSaleAmount(event.target.value);
  };

  const handleFicoChange = (event) => {
    setFico(event.target.value);
  };

  return (
    <main>
      <div className="headerDiv hide-on-print">
        <MortgageHeader />
      </div>
      <span className="hide-on-print">
        <span className={isMobile ? 'mobileHeaderApplyButton' : 'headerApplyButton'}>
          {/* TODO: Apply link used to include lo referrer, who is the new referrer (see prospect ui)? */}
          <Button id="apply_btn_top" url={`${applyLink}`}>Apply</Button>
        </span>
      </span>
      <Col>
        <Row className="refiRow">
          {pmi && (
            <div>
              <h1>
                Calculate PMI:
                {pmi}
              </h1>
            </div>
          )}
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="Original Balance" value={originalBalance} onBlur={(e) => { handleOriginalBalanceChange(e); }} />
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="Sale Amount" value={saleAmount} onBlur={(e) => { handleSaleAmountChange(e); }} />
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="FICO" value={fico} onBlur={(e) => { handleFicoChange(e); }} />
        </Row>
        <Row className="refiRow">
          <Button id="viewClosingCostButton" variant="secondary" onClick={() => handleCalculate()}>
            Calculate
          </Button>
        </Row>
      </Col>
    </main>
  );
}

export default TestPmiCalculator;
